module.exports = __webpack_public_path__ + "img/entp.d799e01f.png";